import isEmpty from 'lodash/isEmpty';
import { AttributionMode } from 'modules/domains/campaign';
import { JourneyConversion } from 'modules/journey/components/JourneyConversions';

export const hydrateJourneyGoalConversion = (conversion: JourneyConversion) => {
  /*
    The backend is expecting an array of goals, so we need to wrap the conversion in an array.  Within that goal, you can
    have multiple conversions, but we only support one for now.
    [
      [{
        eventName: 'testEvent',
        attributionMode: 'AttributionPeriod',
        attributionPeriodHours: 24,
      }, {
        eventName: 'testEvent2',
        attributionMode: 'AttributionPeriod',
        attributionPeriodHours: 24,
      }],
      [
        // additional conversions here
      ],
      ]
    ]
  */
  if (isEmpty(conversion?.event)) return null;
  const eventName = conversion?.event;
  const attributionMode =
    conversion?.mode === AttributionMode.ExplicitlySet
      ? conversion?.mode
      : AttributionMode.AttributionPeriod;
  const attributionPeriodHours =
    conversion?.mode === AttributionMode.LastMessaged
      ? parseInt(conversion?.periodHours, 10)
      : null;
  return [
    [
      {
        eventName,
        attributionMode,
        attributionPeriodHours,
      },
    ],
  ];
};
